<template>
  <section id="modalites" class="relative overflow-hidden py-24 px-6 md:px-12">
    <div class="absolute inset-0 pointer-events-none" aria-hidden="true">
      <div class="dandelion dandelion-2 absolute top-[10%] left-[5%] w-24 h-32 sm:w-32 sm:h-40 rotate-[8deg]" />
      <div
        class="dandelion dandelion-1 absolute bottom-[8%] right-[4%] w-28 h-36 sm:w-36 sm:h-44 -scale-x-100 rotate-[-10deg]" />
    </div>
    <div class="relative max-w-5xl mx-auto flex flex-col gap-12">
      <div class="flex flex-col gap-3 text-center">
        <p class="uppercase tracking-[0.3em] text-sm text-terracotta-600 dark:text-terracotta-400 font-medium">
          Informations pratiques</p>
        <h2 class="text-3xl md:text-4xl text-stone-900 dark:text-stone-50">Localisation &amp; Modalités</h2>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          class="flex flex-col gap-4 p-6 rounded-xl bg-white/70 dark:bg-stone-900/60 border border-stone-200 dark:border-stone-800 backdrop-blur-sm">
          <div
            class="w-12 h-12 rounded-lg bg-terracotta-100 dark:bg-terracotta-900/40 flex items-center justify-center">
            <i class="pi pi-map-marker text-xl text-terracotta-700 dark:text-terracotta-300" aria-hidden="true" />
          </div>
          <h3 class="text-lg text-stone-900 dark:text-stone-50">Localisation</h3>
          <address class="not-italic flex flex-col gap-1 text-stone-600 dark:text-stone-300 leading-relaxed">
            <span>Maison de santé de Javerlhac</span>
            <span>133 Impasse de la Florentine</span>
            <span>24300 Javerlhac-et-la-Chapelle-Saint-Robert</span>
          </address>
          <p class="text-sm text-stone-600 dark:text-stone-400 leading-relaxed">
            Je reçois des patients venant de Javerlhac, ainsi que de communes proches telles que Nontron, Montbron, La
            Rochefoucauld et Angoulême.
          </p>
          <p class="text-sm text-stone-600 dark:text-stone-400 leading-relaxed">
            Je propose également la téléconsultation en fonction des préférences de chacun.
          </p>
        </div>
        <div
          class="flex flex-col gap-4 p-6 rounded-xl bg-white/70 dark:bg-stone-900/60 border border-stone-200 dark:border-stone-800 backdrop-blur-sm">
          <div
            class="w-12 h-12 rounded-lg bg-terracotta-100 dark:bg-terracotta-900/40 flex items-center justify-center">
            <i class="pi pi-clock text-xl text-terracotta-700 dark:text-terracotta-300" aria-hidden="true" />
          </div>
          <h3 class="text-lg text-stone-900 dark:text-stone-50">Modalités</h3>
          <ul class="flex flex-col gap-3 text-stone-600 dark:text-stone-300 leading-relaxed">
            <li class="flex items-start gap-3">
              <i class="pi pi-hourglass shrink-0 w-5 text-center mt-1 text-terracotta-600 dark:text-terracotta-400"
                aria-hidden="true" />
              <span>Séance de 45 minutes</span>
            </li>
            <li class="flex items-start gap-3">
              <i class="pi pi-euro shrink-0 w-5 text-center mt-1 text-terracotta-600 dark:text-terracotta-400"
                aria-hidden="true" />
              <span>50&nbsp;€ la séance</span>
            </li>
            <li class="flex items-start gap-3">
              <i class="pi pi-credit-card shrink-0 w-5 text-center mt-1 text-terracotta-600 dark:text-terracotta-400"
                aria-hidden="true" />
              <span>Modes de paiement acceptés&nbsp;: carte bancaire, espèces, chèques</span>
            </li>
          </ul>
        </div>
      </div>
      <a href="https://www.ameli.fr/assure/remboursements/rembourse/remboursement-seance-psychologue-mon-soutien-psy"
        target="_blank" rel="noopener noreferrer"
        class="card-hover group flex flex-col sm:flex-row sm:items-center gap-4 p-6 rounded-xl bg-terracotta-50/80 dark:bg-terracotta-950/40 border border-terracotta-200 dark:border-terracotta-900 backdrop-blur-sm">
        <div
          class="w-12 h-12 shrink-0 rounded-lg bg-terracotta-100 dark:bg-terracotta-900/40 flex items-center justify-center">
          <i class="pi pi-shield text-xl text-terracotta-700 dark:text-terracotta-300" aria-hidden="true" />
        </div>
        <div class="flex flex-col gap-1">
          <h3 class="text-lg text-stone-900 dark:text-stone-50">Partenaire du dispositif Mon Soutien Psy</h3>
          <p class="text-sm text-stone-600 dark:text-stone-300 leading-relaxed">
            Vos séances peuvent être prises en charge par l'Assurance Maladie. Vérifiez votre éligibilité en ligne.
          </p>
        </div>
        <span
          class="sm:ml-auto shrink-0 inline-flex items-center gap-2 text-sm font-medium text-terracotta-700 dark:text-terracotta-300 group-hover:underline">
          Vérifier mon éligibilité
          <i class="pi pi-external-link text-xs" aria-hidden="true" />
        </span>
      </a>
    </div>
  </section>
</template>
